import genesisIllustrations from './galGenesisIllustrations.json';
import exodusIllustrations from './galExodusIllustrations.json';
import leviticusIllustrations from './galLeviticusIllustrations.json';

export const GAL_EDITIONS = {
  genesis: {
    name: '創世記',
    label: 'GENESIS',
    headline: '世界のはじまり、バリすごくない？',
    images: 'gal-genesis',
    version: 2,
    illustrations: genesisIllustrations,
  },
  exodus: {
    name: '出エジプト記',
    label: 'EXODUS',
    headline: '自由への一歩、一緒に踏み出そ。',
    images: 'gal-exodus',
    version: 1,
    illustrations: exodusIllustrations,
  },
  leviticus: {
    name: 'レビ記',
    label: 'LEVITICUS',
    headline: '毎日の大切なこと、一緒に見つけよ。',
    images: 'gal-leviticus',
    version: 1,
    illustrations: leviticusIllustrations,
  },
};
